import { memo } from 'react'

const TableAndMatchInfo = memo(({ tableId, matchId, roundId }) => {
    return (
        <div className='tableAndMatchInfo tableDetails_header'>
            <span>Table Id : {tableId}</span>
            <span>Match Id : {roundId}</span>
            <span>Round Id : {matchId}</span>
        </div>
    )
})

export default TableAndMatchInfo